export default __webpack_public_path__ + "static/media/Content5.211bbf1d.png";